import {registerBrick} from 'olympe';
import {ReactBrick, useProperty} from '@olympeio/core';
import React from 'react';
import {orangeTheme} from './_theme';
import {Tab, Tabs, ThemeProvider} from '@mui/material';
import {map} from 'rxjs/operators';
import AppController, {AppStates} from '../controllers/AppController';

/**
 * Brick that display a Tabs mui component
 */
export default class MUITabs extends ReactBrick {
    /**
     * @override
     */
    setupExecution($) {
        return $.observe('Tabs name').pipe(map((tabs) => tabs.split(',')));
    }

    /**
     * @override
     */
    static getReactComponent($) {
        return (props) => {
            const tabs = props.values;
            const selectedTab = useProperty($, 'Selected tab');
            const setCurrentTab = (_, newValue) =>{
                AppController.setNewAppState(AppStates.IDLE);
                $.set('Selected tab', newValue);
                $.trigger('On Change Tab');
            };

            return selectedTab ? (
                <ThemeProvider theme={orangeTheme}>
                    <Tabs value={selectedTab} onChange={setCurrentTab} orientation={$.get('Orientation')}>
                        {tabs.map((tab, idx) => {
                            return (
                                <Tab key={'tab' + idx} label={tab} value={tab}/>
                            );
                        })}
                    </Tabs>
                </ThemeProvider>
            ) : null;
        };
    }
}

registerBrick('017c7a038f819ea89225', MUITabs);
